import React, { useEffect } from 'react';
import { Layers } from '@craftjs/layers';

const FilteredLayers = ({ expandRootOnLoad, renderLayer }) => {
  useEffect(() => {
    const originalError = console.warn;

    console.warn = (...args) => {
      const msg = args[0];

      if (
        (typeof msg === 'string' && msg?.includes('Cannot read properties')) ||
        msg?.message?.includes('Cannot read properties') ||
        msg?.includes('query.createNode([object Object]) will be deprecated')
      ) {
        return;
      }
      originalError(...args);
    };

    return () => {
      console.warn = originalError;
    };
  }, []);

  return (
    <Layers expandRootOnLoad={expandRootOnLoad} renderLayer={renderLayer} />
  );
};

export default FilteredLayers;
